import type { Calendar } from "react-date-object";

function mod(first: number, second: number) {
  return ((first % second) + second) % second;
}

function isJalaliLeap(year: number) {
  const y = year - (year >= 0 ? 474 : 473);
  const yCycle = mod(y, 2820) + 474;

  return ((yCycle + 38) * 682) % 2816 < 682;
}

export const persian: Calendar = {
  name: "persian",
  startYear: 1,
  yearLength: 365,
  epoch: 1_948_319,
  century: 14,
  weekStartDayIndex: 0,

  getMonthLengths: (isLeap) => [
    31,
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    isLeap ? 30 : 29,
  ],
  isLeap(year) {
    return isJalaliLeap(year);
  },
  getLeaps(year) {
    if (year === 0) return [];
    const dir = year > 0 ? 1 : -1;
    const leaps = [];

    for (let y = dir; dir > 0 ? y <= year : y >= year; y += dir) {
      if (isJalaliLeap(y)) leaps.push(y);
    }
    return leaps;
  },
  getDayOfYear({ month: { index }, day }) {
    return (index <= 6 ? 31 * index : 186 + 30 * (index - 6)) + day;
  },
  getAllDays(date) {
    const { year } = date;
    const leapsUpToYear = this.getLeaps(year);
    const isCurrentLeap = this.isLeap(year);
    const leapDaysBeforeThisYear = isCurrentLeap
      ? leapsUpToYear.length - 1
      : leapsUpToYear.length;

    let res =
      this.yearLength * (year - 1) +
      leapDaysBeforeThisYear +
      this.getDayOfYear(date);

    if (year === 1404) {
      res += 1;
    }

    return res;
  },

  guessYear: (days, currentYear) => {
    return Math.trunc((days + 0.5) / 365.241) + (currentYear > 0 ? 1 : -1);
  },
};
